import styled from "styled-components";

export const InputContainer = styled.label`
  position: relative;
  font-family: Lato;

  #required-label {
    color: red;
  }

  > span {
    color: #111;
    font-family: Lato;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px;
    letter-spacing: 0.018px;

    position: absolute;
    background: linear-gradient(to bottom, #fff 70%, transparent 30%);
    padding: 0 4px;
    left: 16px;
    top: -6px;
    z-index: 1;
  }

  .react-datepicker-popper {
    z-index: 2;
  }

  input {
    border: 1px solid #111;
    border-radius: 10px;
    height: 44px;
    width: 100%;
    padding: 0 16px;

    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    outline: none;
    display: flex;
    align-items: center;
  }

  textarea {
    border: 1px solid #111;
    border-radius: 10px;
    width: 100%;
    padding: 16px;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    outline: none;
  }

  input:disabled,
  textarea:disabled {
    border: 1px solid #ccc;
  }

  &:has(input:disabled),
  &:has(textarea:disabled) {
    span,
    #required-label {
      color: #9d9d9d;
      background: linear-gradient(
        to bottom,
        #fff 60%,
        rgba(239, 239, 239, 0.3) 50%
      );
    }

    img {
      filter: brightness(0) saturate(100%) invert(70%) sepia(0%) saturate(1%)
        hue-rotate(43deg) brightness(90%) contrast(90%);
    }
  }
`;
